import React, { Fragment } from 'react';
import Loader from '../../component/common/loader/loader';
import Header from '../../component/common/header/header';
import Sidebar from '../../component/common/sidebar/sidebar';
import Rightsidebar from '../../component/common/sidebar/rightsidebar';
import Footer from '../../component/common/footer/footer';

const MainLayout = ({ children, embed = false }) => (
  <Fragment>
    <Loader />
    <div className="page-wrapper">
      <div className="page-body-wrapper">
        {!embed && <Header />}
        <Sidebar />
        <Rightsidebar />
        <div className="page-body">
          {children}
        </div>
        {!embed && <Footer />}
      </div>
    </div>
  </Fragment>
);

export default MainLayout;
